import { Static } from '../../../../../static';

const Footer = () => {
	return (
		<div className='ms-5 me-5 mt-3 mb-3'>
			<p>
				<strong>P.R.T S.p.A.</strong> Sede legale in Beinasco (TO), via Frejus
				n.5 Capitale sociale € 416.000,00 i.v. - R.E.A. di Torino n. 450894
				Registro Imprese di Torino e C.F n. 00487700015 - P.I. IT00487700015
				{' - '}
				<a
					className='app-link'
					href={Static.urlDemoPrivacy}
					target='_blank'
					rel='noopener noreferrer'
				>
					Cookie Policy
				</a>
			</p>
		</div>
	);
};

export default Footer;
